// メインエントリーポイント

import './style.css';
import { init } from './app';
import { AD_CONFIG } from './config/ads-config';

console.log('Win Batch Gen - 開発環境で起動中...');
console.log('広告設定:', AD_CONFIG.enabled ? '有効' : '無効');

// アプリケーション初期化
document.addEventListener('DOMContentLoaded', async () => {
    console.log('DOM読み込み完了');
    await init();
});

